import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React from "react";
import { QuickViewBody } from "../QuickViewBody/QuickViewBody";
import { QuickViewFooter } from "../QuickViewFooter/QuickViewFooter";
import { QuickViewHeader } from "../QuickViewHeader/QuickViewHeader";
import { QuickViewHeaderActions } from "../QuickViewHeaderActions/QuickViewHeaderActions";
export var splitQuickViewChildren = function (children) {
  var _React$Children$toArr;
  return null === (_React$Children$toArr = React.Children.toArray(children)) || void 0 === _React$Children$toArr ? void 0 : _reduceInstanceProperty(_React$Children$toArr).call(_React$Children$toArr, function (acc, child) {
    return child.type === QuickViewHeader ? _objectSpread(_objectSpread({}, acc), {}, {
      header: child
    }) : child.type === QuickViewHeaderActions ? _objectSpread(_objectSpread({}, acc), {}, {
      actions: child
    }) : child.type === QuickViewBody ? _objectSpread(_objectSpread({}, acc), {}, {
      body: child
    }) : child.type === QuickViewFooter ? _objectSpread(_objectSpread({}, acc), {}, {
      footer: child
    }) : acc;
  }, {});
};